<app-popover (closeCallback)="cancelCallback()" size="send-communication" titleText="Send Communication"
  [scrollable]="true" [fullHeight]="true">
  <div popover-content>
    <form [formGroup]="formDetails" *ngIf="formDetails">
      <div class="field-wrapper">
        <!-- <label class="field-label">Send</label> -->
        <app-radio-group [formControl]="formDetails.get('action')" [options]="visibleCommunicationType">
        </app-radio-group>
      </div>

      <div class="field-wrapper">
        <label class="field-label">Select Recipient</label>
        <div class="options">
          <ng-container *ngFor="let recipient of recipientType">
            <ng-container *ngIf="checkVisibility(this.config[recipient.value].config)">
              <div class="option" *ngIf="recipient.value != 'transportManager'">
                <app-radio-button class="option-radio" [option]="recipient"
                  [selectedValue]="formDetails.get('recipientType').value" name="recipientType"
                  (changeCallback)="onRecipientChange($event)">
                </app-radio-button>
                <!-- <app-multiselect
                  class="option-dropdown"
                  [width]="'176px'"
                  [dropdownListWidth]="'179px'"
                  [label]="recipient.dropdownLabel"
                  [formControl]="formDetails.get(recipient.value)"
                  [getCustomOptionValue]="getOptionValue"
                  [recipientType]="updatedRecipientType"
                  [options]="getOptions(recipient.value)">
                </app-multiselect> -->
                <app-dropdown-checkbox [width]="'186px'" [dropdownListWidth]="'186px'" class="option-dropdown"
                  [label]="recipient.dropdownLabel" [formControl]="formDetails.get(recipient.value)"
                  [getCustomOptionValue]="getOptionValue" [getCustomOptionLabel]="getOptionLabel"
                  [recipientType]="updatedRecipientType" [options]="getOptions(recipient.value)">
                </app-dropdown-checkbox>
              </div>
              <div class="option" *ngIf="recipient.value == 'transportManager'">
                <app-radio-button class="option-radio" [option]="recipient"
                  [selectedValue]="formDetails.get('recipientType').value" name="recipientType"
                  (changeCallback)="onRecipientChange($event)">
                </app-radio-button>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="field-wrapper template-field">
        <label class="template-field-label">Type Of Template</label>
        <app-select class="template-dropdown" label="Select Template" type="dropdown" 
          [formControl]="formDetails.get('templateName')" [options]="getTemplateOptions()"
          [getCustomOptionValue]="getTemplateName" [getCustomOptionLabel]="getTemplateName">
        </app-select>
      </div>
      <div class="no-preview" *ngIf="!formDetails.get('templateName').value">
        <!-- No template selected for preview -->
        <img src="assets/images/Group 794179.svg" alt="">
      </div>
      <div *ngIf="formDetails.get('templateName').value && selectedMessage">
        <div class="field-wrapper" *ngIf="formDetails.get('action').value == 'Email'">
          <label class="field-label">Subject</label>
          <div class="subject-preview mb-10">
            {{selectedMessage.tempSub}}
          </div>
        </div>
        <div class="field-wrapper">
          <label class="field-label">Message preview</label>
          <div class="message-preview" [innerHtml]="selectedMessage.tempBody"></div>
        </div>
      </div>
      <div *ngIf="formDetails.get('templateName').value && !selectedMessage">
        <div class="field-wrapper" *ngIf="formDetails.get('action').value == 'Email'">
          <label class="field-label">Subject</label>
          <app-text-input placeholder="Type subject" [formControl]="formDetails.get('tempSub')">
          </app-text-input>
        </div>
        <div class="field-wrapper">
          <label class="field-label">Message</label>
          <app-text-input [multiline]="true" placeholder="Type subject" [formControl]="formDetails.get('tempBody')">
          </app-text-input>
        </div>
      </div>
    </form>
  </div>
  <div popover-actions class="actions-block">
    <app-button (clickCallback)="cancelCallback()" class="mr-10" type="plainText" text="Cancel"></app-button>
    <app-button (clickCallback)="onSubmitClick()" type="primaryFilled" text="Send"></app-button>
  </div>
</app-popover>

<app-loader *ngIf="isLoading"></app-loader>